<template>
    <div>
        <validation-observer ref="observer" v-slot="{ passes }">
            <span v-if="!updateItem" @dblclick="updateItem = true">
                <strong>{{ item?.tag }}</strong>
                <span class="text-muted ml-2">- {{ item?.name }}</span>
            </span>
            <b-form v-if="updateItem" inline @submit.prevent="passes(onFormSubmit)" novalidate>
                <b-button size="sm" class="mr-1" variant="warning" @click="updateItem = false">Undo</b-button>
                <validation-provider vid="tag" v-slot="{ errors }">
                    <b-form-input size="sm" :state="errors[0] ? false : null" id="tag" name="tag" v-model="form.tag" v-capitalize class="mr-1" placeholder="Add tag..." />
                </validation-provider>
                <validation-provider vid="name" v-slot="{ errors }">
                    <b-form-input size="sm" :state="errors[0] ? false : null" id="name" name="name" v-model="form.name" v-capitalize class="mr-1" placeholder="Add name..." />
                </validation-provider>
                <b-button size="sm" type="submit" class="ml-1" variant="success">Update</b-button>
                <b-button size="sm" type="button" class="ml-1" variant="danger" @click="onDelete">Delete</b-button>
            </b-form>
        </validation-observer>
    </div>
</template>

<script>
import FormExtension from "@/core/components/FormExtension"
import { mapActions } from "vuex"

export default FormExtension.extend({
    name: 'update-diagnostic-category',
    props: ['item'],
    data() {
        return {
            form: new Form({
                tag: "",
                name: "",
                consistency_token: null
            }),

            updateItem: false
        }
    },
    watch: {
        form: {
            deep: true,
            handler(val) {
                this.isDirty = this.form.dirty()

                if (this.isDirty) {
                    this.dirty()
                }else{
                    this.validated()
                }
            }
        },
        item: {
            immediate: true,
            handler(val) {
                this.form.withData(val)
            }
        },
    },
    methods: {
        ...mapActions('patients', ['updateDiagnosticCategoryById', 'deleteDiagnosticCategoryById']),
        onFormSubmit() {
            this.updateDiagnosticCategoryById({
                id: this.item.id, 
                data: this.form.data()
            }).then(() => {
                this.reset()
                this.notify('Diagnostic category updated', "Diagnostic category was updated successfully")
                this.$emit('updated')
            })
            .catch(errors => {
                if (errors.response) {
                    this.$refs.observer?.setErrors(errors.response.data)
                    this.hasErrors = true
                }
            })
        },
        onDelete() {
            this.deleteDiagnosticCategoryById(this.item?.id).then(() => {
                this.notify('Diagnostic category deleted', "Diagnostic category was deleted successfully")
                this.updateItem = false
                this.validated()
                this.$emit('updated')
            })
        },
        reset() {
            this.form.reset()
            this.$nextTick(() => {
                this.$refs.observer?.reset()
                this.updateItem = false
                this.hasErrors = false
                this.validated()
            })
        }
    }
})
</script>
